const action = "SEGMENT_DETAIL";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const FAILURE = action+'_FAILURE';
export const CLEAR = action+'_CLEAR';

export const fetchRequest = (segmentId) => {
    return {
        type: REQUEST,
        payload: segmentId
    };
};

export const fetchSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});

export const clearState = () => ({
  type: CLEAR
}); 